import { type FC } from 'react'
import { Navigate } from 'react-router'
import { WEALTH_ROUTES } from '@egw/constants'
import { ROUTES } from '../../../constants/routes/routes-joint'

export const HomePage: FC = () => {
  return <Navigate to={`${WEALTH_ROUTES.ENROLLMENT.path}/${ROUTES.SELECT_ACCOUNT.path}`} replace />
}
